import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';

import appReducer from '@/redux/app/appSlice';
import authReducer from '@/redux/auth/authSlice';
import userReducer from '@/redux/user/userSlice';
import profileReducer from '@/redux/profile/profileSlice';
import accountsReducer from '@/redux/accounts/accountsSlice';
import depositReducer from '@/redux/deposit/depositSlice';
import transferReducer from '@/redux/transfer/transferSlice';
import withdrawReducer from '@/redux/withdraw/withdrawSlice';
import presetsReducer from '@/redux/presets/presetsSlice';
import notificationsReducer from '@/redux/notifications/notificationsSlice';
import supportReducer from '@/redux/support/supportSlice';
import partnerReducer from '@/redux/partner/partnerSlice';
import utmReducer from '@/redux/utm/utmSlice';
import pammReducer from '@/redux/pamm/pammSlice';

const storage =
  typeof window !== 'undefined'
    ? {
        getItem: key => Promise.resolve(localStorage.getItem(key)),
        setItem: (key, value) => {
          localStorage.setItem(key, value);
          return Promise.resolve(value);
        },
        removeItem: key => {
          localStorage.removeItem(key);
          return Promise.resolve();
        },
      }
    : {
        getItem: () => Promise.resolve(null),
        setItem: (_key, value) => Promise.resolve(value),
        removeItem: () => Promise.resolve(),
      };

const authPersistConfig = {
  key: 'auth',
  storage,
};

const rootReducer = combineReducers({
  app: appReducer,
  auth: persistReducer(authPersistConfig, authReducer),
  user: userReducer,
  profile: profileReducer,
  accounts: accountsReducer,
  deposit: depositReducer,
  transfer: transferReducer,
  withdraw: withdrawReducer,
  presets: presetsReducer,
  notifications: notificationsReducer,
  support: supportReducer,
  partner: partnerReducer,
  utm: utmReducer,
  pamm: pammReducer,
});

const customizedMiddleware = getDefaultMiddleware =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: ['persist/PERSIST'],
    },
  });

export const store = configureStore({
  reducer: rootReducer,
  middleware: customizedMiddleware,
  devTools: import.meta.env.VITE_NODE_ENV === 'development',
});

export const persistor = persistStore(store);

export default { store, persistor };
